import { FileDrop } from "components/DragNDrop.js/drag_n_drop";
import MDBox from "components/MDBox";
import ApiCalls from "services/flick_erp_api_call";
import { useState } from "react";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Chip,
  Divider,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import colors from "assets/theme/base/colors";
import { CalendarMonth, CheckCircleOutline, Description } from "@mui/icons-material";

const initialPayload = () => ({
  start_date: "",
  end_date: "",
  file: null,
  start_date_error: false,
  end_date_error: false,
  file_error: false,
});

const fieldSx = {
  //"& .MuiOutlinedInput-root": {
  //  borderRadius: "16px",
  //  backgroundColor: "#fbfcfe",
  //},
};

const sectionCardSx = {
  borderRadius: "24px",
  border: `1px solid ${colors.grey[200]}`,
  boxShadow: "0 16px 35px rgba(15, 23, 42, 0.05)",
  background: colors.background.elevated,
};

export function UploadFile() {
  const navigate = useNavigate();
  const [attendanceUploadPayload, setAttendanceUploadPayload] = useState(initialPayload());

  async function uploadAttendance() {
    let hasError = false;

    if (attendanceUploadPayload?.start_date == undefined || attendanceUploadPayload?.start_date == "") {
      hasError = true;
      setAttendanceUploadPayload((state) => ({ ...state, start_date_error: true }));
    } else {
      setAttendanceUploadPayload((state) => ({ ...state, start_date_error: false }));
    }

    if (attendanceUploadPayload?.end_date == undefined || attendanceUploadPayload?.end_date == "") {
      hasError = true;
      setAttendanceUploadPayload((state) => ({ ...state, end_date_error: true }));
    } else {
      setAttendanceUploadPayload((state) => ({ ...state, end_date_error: false }));
    }

    if (attendanceUploadPayload?.file == undefined || attendanceUploadPayload?.file == "") {
      hasError = true;
      setAttendanceUploadPayload((state) => ({ ...state, file_error: true }));
    } else {
      setAttendanceUploadPayload((state) => ({ ...state, file_error: false }));
    }

    if (!hasError) {
      const formData = new FormData();
      formData.append("start_date", attendanceUploadPayload.start_date);
      formData.append("end_date", attendanceUploadPayload.end_date);
      formData.append("file", attendanceUploadPayload.file);

      const syncFormData = new FormData();
      syncFormData.append("start_date", attendanceUploadPayload.start_date);
      syncFormData.append("end_date", attendanceUploadPayload.end_date);

      const res = await ApiCalls.uploadAttendance(formData, true);
      if (res.success && res.code === 201) {
        const syncRes = await ApiCalls.SyncCsvAttendance(syncFormData, true);

        if (syncRes.success) {
          navigate("/Attendance");
          setAttendanceUploadPayload(initialPayload());
        }
      }
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} lg={7}>
        <Card style={{marginLeft : "13px"}} sx={sectionCardSx}>
          <MDBox p={{ xs: 2.5, md: 3 }}>
            <MDTypography variant="h5" color="dark" fontWeight="bold">
              Attendance Import
            </MDTypography>
            <MDTypography variant="body2" color="text" sx={{ mt: 0.75, mb: 3 }}>
              Select the attendance period and upload the source file to sync employee records.
            </MDTypography>

            <Grid container spacing={2.5}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Start Date"
                  variant="outlined"
                  id="start"
                  type="date"
                  name="start_date"
                  value={attendanceUploadPayload?.start_date || ""}
                  InputLabelProps={{ shrink: true }}
                  error={attendanceUploadPayload?.start_date_error}
                  helperText={
                    attendanceUploadPayload?.start_date_error ? "Start date is required" : ""
                  }
                  onChange={(event) => {
                    setAttendanceUploadPayload((state) => ({
                      ...state,
                      start_date: event.target.value,
                      start_date_error: event.target.value == "",
                    }));
                  }}
                  sx={fieldSx}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="End Date"
                  variant="outlined"
                  id="end_date"
                  type="date"
                  name="end_date"
                  value={attendanceUploadPayload?.end_date || ""}
                  InputLabelProps={{ shrink: true }}
                  error={attendanceUploadPayload?.end_date_error}
                  helperText={attendanceUploadPayload?.end_date_error ? "End date is required" : ""}
                  onChange={(event) => {
                    setAttendanceUploadPayload((state) => ({
                      ...state,
                      end_date: event.target.value,
                      end_date_error: event.target.value == "",
                    }));
                  }}
                  sx={fieldSx}
                />
              </Grid>
            </Grid>

            <MDBox
              mt={3}
              p={2}
              sx={{
                borderRadius: "20px",
                border: `1px solid ${colors.grey[200]}`,
                //background: "#fbfcfe",
              }}
            >
              <MDTypography variant="button" color="text" sx={{ display: "block", mb: 1.5 }}>
                Upload Source File
              </MDTypography>
              <MDBox align="center">
                <FileDrop
                  onDropped={(file) => {
                    setAttendanceUploadPayload((state) => ({
                      ...state,
                      file,
                      file_error: false,
                    }));
                  }}
                  acceptedFiles={[".dat"]}
                  validationError={attendanceUploadPayload?.file_error}
                />
              </MDBox>
              {attendanceUploadPayload?.file_error && (
                <MDTypography variant="caption" sx={{ color: colors.error.main, mt: 1.5 }}>
                  Please upload a valid `.dat` file.
                </MDTypography>
              )}
            </MDBox>

            <MDBox
              mt={3}
              pt={2.5}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
              gap={1.5}
              borderTop={`1px solid ${colors.grey[200]}`}
            >
              <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                <Chip
                  icon={<Description />}
                  label={attendanceUploadPayload?.file?.name || "No file selected"}
                  sx={{
                    borderRadius: "12px",
                    background: "rgba(37, 99, 235, 0.08)",
                    color: colors.info.main,
                    fontWeight: 600,
                  }}
                />
              </Stack>
              <MDButton
                onClick={uploadAttendance}
                color="info"
                sx={{ borderRadius: "14px", px: 4 }}
              >
                Upload Attendance
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
      </Grid>

      <Grid item xs={12} lg={5}>
        <Card style={{marginRight:"13px"}}sx={sectionCardSx}>
          <MDBox p={{ xs: 2.5, md: 3 }}>
            <MDTypography variant="h5" color="dark" fontWeight="bold">
              Upload Guide
            </MDTypography>
            <MDTypography variant="body2" color="text" sx={{ mt: 0.75 }}>
              A quick checklist before syncing attendance into the system.
            </MDTypography>

            <Divider sx={{ my: 2.5 }} />

            <Stack spacing={2}>
              <MDBox
                sx={{
                  p: 2,
                  borderRadius: "18px",
                  background: "rgba(37, 99, 235, 0.06)",
                  border: "1px solid rgba(37, 99, 235, 0.1)",
									alignItems : "center",
									display : "flex",
									gap : 3
                }}
              >
                <CalendarMonth sx={{ color: colors.info.main, mb: 1 }} fontSize="small" />
								<MDBox>
                <MDTypography variant="button" color="dark" fontWeight="medium">
                  Select the exact attendance range
                </MDTypography>
                <MDTypography variant="caption" color="text" sx={{ display: "block", mt: 0.5 }}>
                  Use matching start and end dates so the sync targets the correct period.
                </MDTypography>
								</MDBox>
              </MDBox>

              <MDBox
                sx={{
                  p: 2,
                  borderRadius: "18px",
                  background: "rgba(16, 185, 129, 0.06)",
                  border: "1px solid rgba(16, 185, 129, 0.1)",
									alignItems : "center",
									display : "flex",
									gap : 3
                }}
              >
                <Description sx={{ color: colors.success.main, mb: 1 }} fontSize="small" />
								<MDBox>
									<MDTypography variant="button" color="dark" fontWeight="medium">
                  Upload only supported `.dat` files
                </MDTypography>
                <MDTypography variant="caption" color="text" sx={{ display: "block", mt: 0.5 }}>
                  The importer currently validates `.dat` files before starting the sync flow.
                </MDTypography>
								</MDBox>
                
              </MDBox>

              <MDBox
                sx={{
                  p: 2,
                  borderRadius: "18px",
                  background: "rgba(124, 58, 237, 0.06)",
                  border: "1px solid rgba(124, 58, 237, 0.1)",
									alignItems : "center",
									display : "flex",
									gap : 3
                }}
              >
                <CheckCircleOutline sx={{ color: colors.primary.main, mb: 1 }} fontSize="small" />
								<MDBox>
									<MDTypography variant="button" color="dark" fontWeight="medium">
                  Sync runs automatically after upload
                </MDTypography>
                <MDTypography variant="caption" color="text" sx={{ display: "block", mt: 0.5 }}>
                  After a successful import, the sync request is triggered and you are redirected to attendance.
                </MDTypography>
								</MDBox>
              </MDBox>
            </Stack>
          </MDBox>
        </Card>
      </Grid>
    </Grid>
  );
}
